import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.IS_FULLSCREEN_OPEN](state) {
        return state.fullscreen_overlay_count > 0;
    },
};
